<script setup lang="ts">
const route = useRoute();
const appConfig = useAppConfig();
const { isHelpSlideoverOpen } = useDashboard();

import { useSession } from "~/composables/useSession";
const session = useSession(); // Session composable

const hasSession = computed(() => session.hasSession());

const links = [
  {
    id: "home",
    label: "New Publication",
    icon: "i-heroicons-document-plus",
    to: "/",
    tooltip: {
      text: "New",
      shortcuts: ["G", "N"],
    },
  },
  {
    id: "publications",
    label: "Manage Publications",
    icon: "i-heroicons-squares-2x2",
    to: "/publications",
    tooltip: {
      text: "Manage",
      shortcuts: ["G", "M"],
    },
  } /*,
  {
    id: "login",
    label: "Login",
    icon: "i-heroicons-key",
    to: "/login",
    tooltip: {
      text: "Login",
      shortcuts: ["G", "L"],
    },
  },*/,
];

const groups = [
  {
    key: "links",
    label: "Go to",
    commands: links.map((link) => ({ ...link, shortcuts: link.tooltip?.shortcuts })),
  },
  {
    key: "code",
    label: "Code",
    commands: [
      {
        id: "source",
        label: "View page source",
        icon: "i-simple-icons-github",
        click: () => {
          window.open(
            `https://github.com/nuxt-ui-pro/dashboard/blob/main/pages${route.path === "/" ? "/index" : route.path}.vue`,
            "_blank"
          );
        },
      },
    ],
  },
];

const defaultColors = ref(
  ["green", "teal", "cyan", "sky", "blue", "indigo", "violet"].map((color) => ({
    label: color,
    chip: color,
    click: () => (appConfig.ui.primary = color),
  }))
);
const colors = computed(() =>
  defaultColors.value.map((color) => ({ ...color, active: appConfig.ui.primary === color.label }))
);
</script>

<template>
  <UDashboardLayout>
    <UDashboardPanel :width="250" :resizable="{ min: 200, max: 300 }" collapsible>
      <UDashboardNavbar class="!border-transparent" :ui="{ left: 'flex-1' }"> </UDashboardNavbar>

      <UDashboardSidebar>
        <UDashboardSidebarLinks :links="links" />
        <template v-if="hasSession" #footer>
          <UserDropdown />
        </template>
      </UDashboardSidebar>
    </UDashboardPanel>

    <slot />

    <HelpSlideover />
    <NotificationsSlideover />

    <ClientOnly>
      <LazyUDashboardSearch :groups="groups" />
    </ClientOnly>
  </UDashboardLayout>
</template>
